<div class="edp-card-widget card">
    <div class="card-header">
        <span class="card-title">{{ 'pt.edp.edponline.endpoint.conta.certa.title' | translate }}</span>
        <span class="card-icon">
            <i class="icon-edponline-EDP_Online_payment"  aria-hidden="true"></i>
        </span>
    </div>
    <div *ngIf="loading">
        <edp-loader [size]="'md'" [position]="'center'"></edp-loader>
      </div>
    <div class="card-body" (resized)="chartConstruction()" [ngClass]="{'d-none': loading}">
        <div class="inicial-text" [ngClass]="{'mb-4': month === 12}">
            <span *ngIf="month === 1">{{ 'pt.edp.edponline.endpoint.conta.certa.title' | translate }}<span class="font-weight-bold"> {{ valueContaCerta | edpDotToComma }}€</span></span>
            <ng-container *ngIf="month === 12">
                <span class="title">
                    <span class="font-weight-bold red">{{labelMonthTwelveTitle | translate}}</span>
                    {{ 'pt.edp.edponline.endpoint.conta.certa.label.twelve.month.title' | translate }}
                </span>
                <div class="d-flex mt-4">
                    <div class="my-auto">
                        <span class="value-acerto" [innerHTML]="valueContaCertaAcerto | edpDecimalSplit"></span>
                    </div>
                    <div class="my-auto value-description">
                        <span>{{ labelMonthTwelveValueDescription | translate }}</span>
                    </div>
                </div>
                <span class="information">{{ 'pt.edp.edponline.endpoint.conta.certa.label.twelve.month.taxas' | translate }}</span>
            </ng-container>
        </div>
        <div class="chart d-flex flex-column">
            <div *ngIf="month !== 1" class="legend">
                <div class="text">                    
                    <span class="legend-icons">
                        <div class="line"></div>
                    </span>
                    <span class="ml-2">{{ "pt.edp.edponline.endpoint.conta.certa.chart.legend.average" | translate }}</span>
                    <span class="ml-2 mr-1"><b>{{ valueContaCertaMedia | edpDotToComma }}€</b></span>

                    <ng-container *ngTemplateOutlet="popoverTemplate"></ng-container>
                </div>
                <div class="text">
                    <span>- - -</span>
                    <span class="ml-2">{{ 'pt.edp.edponline.endpoint.conta.certa.title' | translate }}</span>
                    <span class="ml-2"><b>{{ valueContaCerta | edpDotToComma }}€</b></span>
                </div>
            </div>
            <div id="graphicContaCerta" class="card-chart"></div>
            <div *ngIf="hasEstimatedMonths && month >= 3 && month < 11" class="estimated-month-legend align-self-end">
                {{ 'pt.edp.edponline.endpoint.conta.certa.label.estimated.months.legend' | translate }}
            </div>
            <div class="card-chart-overlay" *ngIf="month === 1">
                <span class="card-text">{{ "pt.edp.edponline.endpoint.conta.certa.chart.overlay" | translate }}</span>
            </div>
        </div>
        <div class="description">
            <ng-container *ngIf="month < 3">
                <span [innerHTML]="label | translate"></span>
            </ng-container>
            <ng-container *ngIf="month === 11">
                <span [innerHTML]="label | translate: {'lastMonthContaCerta': lastMonthContaCerta, 'valueContaCertaAcerto': (valueContaCertaAcerto | edpDotToComma)}"></span>
            </ng-container>
            <ng-container *ngIf="month >= 3 && month < 11">
                <ng-container *ngIf="hasEstimatedMonths">
                    <span class="estimated-months" [innerHTML]="'pt.edp.edponline.endpoint.conta.certa.label.estimated.months' | translate: {
                        'startEstimatedMonthLabel': startEstimatedMonthLabel,
                        'endEstimatedMonthLabel': endEstimatedMonthLabel
                    }">
                    </span>
                    <span class="estimated-months" [innerHTML]="'pt.edp.edponline.endpoint.conta.certa.label.estimated.months.warning' | translate"></span>
                </ng-container>
                <ng-container *ngIf="!hasEstimatedMonths">
                    <span>
                        {{ labelMiddleMonths | translate: {'valueContaCerta': valueContaCerta | edpDotToComma} }} <span [innerHTML]="labelMiddleMonthsSecondLabel | translate: {'valueContaCertaAcerto': (valueContaCertaAcerto | edpDotToComma)}"></span>
                    </span>
                    <button (click)="reviewMonthPayment()" class="btn btn-primary w-100 button-final">
                        {{ "pt.edp.edponline.endpoint.conta.certa.button" | translate }}
                    </button>
                </ng-container>
            </ng-container>
        </div>
    </div>
</div>

<ng-template #popoverTemplate>
    <edp-popover #popComponent [popoverContent]="popoverContent"
        [popBtn]="'icon icon-edponline-Bop-025'" [popPlacement]="'bottom'">
        <ng-template #popoverContent>
            <span class="d-block tooltip-text">
                {{ 'pt.edp.edponline.conta.certa.tooltip' | translate }}
            </span>
        </ng-template>
    </edp-popover>
</ng-template>